export const eventsDetailsTab = ['home', 'leaderboard', 'explorationMap', 'explorationMapTest', 'stats', 'potential', 'lots', 'faq'];
export const eventsDetailsTabMap = {
  home: {
    labelKey: 'commons.challenges.navigation.home'
  },
  leaderboard: {
    labelKey: 'commons.challenges.leaderboard.by_companies_title'
  },
  explorationMap: {
    labelKey: 'commons.challenges.navigation.exploration_map'
  },
  explorationMapTest: {
    labelKey: 'commons.challenges.navigation.exploration_map_test'
  },
  faq: {
    labelKey: 'commons.challenges.navigation.faq'
  },
  stats: {
    labelKey: 'commons.challenges.navigation.stats'
  },
  potential: {
    labelKey: 'commons.challenges.navigation.potential'
  },
  lots: {
    labelKey: 'commons.challenges.navigation.lots'
  }
};
export const leaderboardScopes = ['national', 'internal'];
export const leaderboardTypes = ['companies', 'individual', 'holdingCompanies'];
export { eventHasFaqTab, eventHasHomeTab, eventHasLotsTab, eventHasPotentialTab, eventHasStatsTab, getEventFamily } from '../../event-campaigns';